import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useAgreements } from '@retail/purchase-agreements/context';
import { ConditionsNew } from '@retail/calculus/types';
import { CreatePurchaseConditionForm } from '../../../PurchaseConditions';
import { InheritedConditionHint } from './InheritedConditionHint';

interface Props {
  supplierNumber: number;
  editCondition?: ConditionsNew;
}

export function PurchaseStep({ supplierNumber, editCondition }: Props) {
  const { assortmentId } = useSelectedOrgUnit();
  const { agreements } = useAgreements({ supplierNumber });

  return (
    <>
      {editCondition && <InheritedConditionHint area="purchase" condition={editCondition} />}
      <CreatePurchaseConditionForm
        assortmentId={assortmentId}
        supplierNumber={supplierNumber}
        agreements={agreements}
      />
    </>
  );
}
